import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { get, post, put, del, api } from '../api/client.js';

const key = (target) => ['documents', target || 'me'];

export function useDocuments(target) {
  return useQuery({
    queryKey: key(target),
    queryFn: async () => {
      const q = target ? `?user=${encodeURIComponent(target)}` : '';
      return (await get(`/api/documents${q}`)).documents || [];
    },
    staleTime: 30_000,
  });
}

export function useUploadDocument() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (form) => api('/api/documents', { method: 'POST', body: form }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['documents'] }),
  });
}

export function useUpdateDocument() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...body }) => put(`/api/documents/${id}`, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['documents'] }),
  });
}

export function useDeleteDocument() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => del(`/api/documents/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['documents'] }),
  });
}
